import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Modal from "module-common/Modal";
import Button from "module-common/Button";
import TextArea from "module-common/TextArea";
import { Checkbox } from "antd";
import { CommonStore } from "Store";

export default class ConfirmModal extends Component {
  static propTypes = {
    text: PropTypes.string,
    withNote: PropTypes.bool,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func,
    isConfirmLoading: PropTypes.bool
  };
  static defaultProps = {
    withNote: false,
    isConfirmLoading: false
  };
  state = {
    note: "",
    isCsatSent: CommonStore.csatActive
  };

  render() {
    const { text, withNote, onCancel, isConfirmLoading } = this.props;

    return (
      <Modal>
        <Wrapper>
          <Text>{text}</Text>
          {withNote && (
            <WrapperWithNote>
              <TextArea
                placeholder="Write your notes here"
                rows={5}
                onChange={this.onChange}
              />

              <Checkbox
                disabled={!CommonStore.csatActive}
                checked={this.state.isCsatSent}
                onChange={this.onChangeCheckBox}
              >
                Send CSAT
              </Checkbox>
            </WrapperWithNote>
          )}
          <Buttons>
            <Button
              width={100}
              onClick={onCancel}
              color="gray"
              disabled={isConfirmLoading}
            >
              No
            </Button>
            <Button
              width={100}
              onClick={this.onConfirm}
              loading={isConfirmLoading}
              disabled={isConfirmLoading}
            >
              Yes
            </Button>
          </Buttons>
        </Wrapper>
      </Modal>
    );
  }

  onChange = event => {
    this.setState({
      note: event.target.value
    });
  };

  onChangeCheckBox = event => {
    this.setState({
      isCsatSent: event.target.checked
    });
  };

  onConfirm = () => {
    const onConfirm = this.props.onConfirm;
    if (onConfirm) onConfirm(this.state.note, this.state.isCsatSent);
  };
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 350px;
`;
const Text = styled.div`
  color: ${props => props.theme.uiText};
  font-size: 1rem;
  text-align: center;
  margin-bottom: 10px;
`;
const Buttons = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  & > *:first-child {
    margin-right: 20px;
  }
`;

const WrapperWithNote = styled.div``;



// WEBPACK FOOTER //
// ./src/module-common/ConfirmModal.js